import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const flightService = {
  getOffersByBasketId: (payload = {}, headers = {}, hasErrorHandler = true) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.getOffersByBasketId,
      payload: {
        Code: payload.Code,
        OfferType: payload.OfferType,
      },
      headers,
      hasErrorHandler,
    }),
  getCheckinUrl: (payload = {}, headers = {}, hasErrorHandler = true) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.getCheckinUrl,
      payload: {
        AirlineCode: payload.AirlineCode,
        BasketId: payload.BasketId,
      },
      headers,
      hasErrorHandler,
    }),
  insertRefundOffers: (payload = {}, headers = {}, hasErrorHandler = true) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.insertRefundOffers,
      payload,
      headers,
      hasErrorHandler,
    }),
  insertReissueOffers: (payload = {}, headers = {}, hasErrorHandler = true) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.insertReissueOffers,
      payload,
      headers,
      hasErrorHandler,
    }),
  updateOfferStatus: (payload = {}, headers = {}, hasErrorHandler = true) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.updateOfferStatus,
      payload: {
        OfferId: payload.OfferId,
        Status: payload.Status,
        OfferType: payload.OfferType,
      },
      headers,
      hasErrorHandler,
    }),
  getFlightSuggestions: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.flight.getFlightSuggestions,
      payload,
      headers,
      hasErrorHandler,
    }),
  getFlightSuggestionsByQuery: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.flight.getFlightSuggestionsByQuery,
      payload,
      headers,
      hasErrorHandler,
    }),
  getPopularCities: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.getPopularCities,
      payload,
      headers,
      hasErrorHandler,
    }),
  getNearestAirports: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.getNearestAirports,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCheapestFlightsMonthly: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.getCheapestFlightsMonthly,
      payload,
      headers,
      hasErrorHandler,
    }),
  getCheapestFlightsTo: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.getCheapestFlightsTo,
      payload,
      headers,
      hasErrorHandler,
    }),
  getOneWayCalendarPrices: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.getOneWayCalendarPrices,
      payload,
      headers,
      hasErrorHandler,
    }),
  getRoundTripCalendarPrices: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.getRoundTripCalendarPrices,
      payload,
      headers,
      hasErrorHandler,
    }),
  getFlightDefaultOrigin: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.getFlightDefaultOrigin,
      payload,
      headers,
      hasErrorHandler,
    }),
  reservationOrderCreate: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flightAllocate.reservationOrderCreate,
      payload,
      headers,
      hasErrorHandler,
    }),
  parseSearchQuery: (
    query = "",
    headers = {},
    hasErrorHandler = false,
    langCode = "",
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.flight.parseSearchQuery,
      payload: { query, langCode },
      headers,
      hasErrorHandler,
    }),
  getBasketForReservationLink: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flightAllocate.getBasketForReservationLink,
      payload,
      headers,
      hasErrorHandler,
    }),
};
